import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dialogBody]',
})
export class DialogBody {
  constructor(public templateRef: TemplateRef<any>) {}
}
